module.exports = __webpack_public_path__ + "static/media/what_is_lag.54656d43.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Lag/images/animations/what_is_lag.mp4
// module id = 1493
// module chunks = 39